// #region Imports
import React, { useEffect, useState, useRef } from "react"
import { useDispatch } from "react-redux"
import {
  Button,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  InputGroup,
  Label,
  Nav,
  NavItem,
  NavLink,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import CreatableSelect from "react-select/creatable"
import { useFormik } from "formik"
import * as Yup from "yup"

import Flatpickr from "react-flatpickr"
import "flatpickr/dist/themes/material_blue.css"
import { Spanish } from "flatpickr/dist/l10n/es.js"
import classnames from "classnames"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import FormikDatePicker from "../Common/Formik/FormikDatePicker"
import CustomPagination from "../Common/CustomPagination"
import FormularioGastos from "../Common/FormularioGastos"
import FormularioGastosReadOnly from "../Common/FormularioGastos"

// #endregion

// #region selectors
import {
  useAuthPermiso,
  useAuthIdPersonaAuthenticated,
  useCajaConceptosGasto,
  useCajaConceptosGastoOptions,
  useCajaConceptosGastoIsLoading,
  useCampusVirtualIdCampus,
  useCampusVirtualNombreCampusSeleccionado,
  useCajaMensajeExitoso,
  useCajaGastos,
} from "store/selectors"
// #endregion

// #region actions
import {
  putControlEscolarPutoDireccion as onPutControlEscolarPutoDireccion,
  ControlEscolarUnsetNotificacion,
  getCajaConceptosGasto,
  postCajaAddGasto,
  unsetCajaMensajeExito,
  getCajaGastos,
} from "../../store/actions"
// #endregion

const hoy = new Date()
const primerDiaMes = new Date(
  new Date().getFullYear(),
  new Date().getMonth(),
  1
)

const GastosComponent = ({ idAlumno, oPersona, isEdit }) => {
  let initialValuesConsulta = {
    Fecha_Desde: primerDiaMes,
    Fecha_Hasta: hoy,
  }
  //
  // Define la expresión regular para sanitizar
  const regex = /^[A-Za-zÁÉÍÓÚáéíóúÑñÜü\s]*$/
  //
  //console.log("formik.errors", formik.errors)
  //
  // #region react-redux
  const dispatch = useDispatch()
  // #endregion

  // #region Options
  let defaultOptions = []

  const optionsFlatpickr = {
    locale: Spanish,
    altInput: true,
    dateFormat: "d-m-y",
  }

  const documentosOptions = [
    { value: 13, label: "Este Mismo" },
    { value: 14, label: "Nota Remisión" },
    { value: 15, label: "Factura" },
    { value: 16, label: "Recibo" },
  ]

  const formaPagoOptions = [
    { value: 1, label: "Efectivo" },
    { value: 2, label: "Cheque" },
    { value: 3, label: "Vales" },
  ]

  const costosOptions = [
    { value: 2, label: "Administración" },
    { value: 1, label: "Contabilidad" },
    { value: 3, label: "Extensión" },
    { value: 4, label: "Infraestructura y Mantenimiento" },
    { value: 5, label: "Investigación" },
    { value: 6, label: "Servicios Estudiantiles" },
    { value: 7, label: "Tecnología y Recursos Informáticos" },
  ]
  // #endregion

  // #region useRef
  const flatpickrRef = useRef(null)
  const inputRef = useRef(null)
  // #endregion

  // #region const-selectors
  const isAdministradorGeneral = useAuthPermiso(["sis_administrador_general"])
  const idPersonaAuthenticated = useAuthIdPersonaAuthenticated()

  const conceptosGasto = useCajaConceptosGasto()
  const conceptosGastoOptions = useCajaConceptosGastoOptions()
  const isLoadingConceptosGasto = useCajaConceptosGastoIsLoading()
  const idCampus = useCampusVirtualIdCampus()
  const mensajeExitoso = useCajaMensajeExitoso()
  const gastos = useCajaGastos()
  // #endregion

  // #region Internal States
  const [customActiveTab, setcustomActiveTab] = useState("1")

  const [importe, setImporte] = useState(0)

  const [isLoading, setIsLoading] = useState(false)
  const [optionsPersonaRecibeRecurso, setOptionsPersonaRecibeRecurso] =
    useState(defaultOptions)
  const [valuePersonaRecibeRecurso, setValuePersonaRecibeRecurso] =
    useState(null)
  const [optionsPersonaEntregoRecurso, setOptionsPersonaEntregoRecurso] =
    useState(defaultOptions)
  const [valuePersonaEntregoRecurso, setValuePersonaEntregoRecurso] =
    useState(null)
  const [optionsPersonaAutorizoRecurso, setOptionsPersonaAutorizoRecurso] =
    useState(defaultOptions)
  const [valuePersonaAutorizoRecurso, setValuePersonaAutorizoRecurso] =
    useState(null)

  const [inputValue, setInputValue] = useState("")

  //
  const [numeroTotalGastos, setNumeroTotalGastos] = useState(0)
  const [numeroRegistroGasto, setNumeroRegistroGasto] = useState(0)
  const [gastoCurrent, setGastoCurrent] = useState({})
  const [opcionesConceptosGasto, setOpcionesConceptosGasto] = useState(
    conceptosGastoOptions
  )

  // #endregion

  // #region useEffects
  // Al montar el componente, leemos de localStorage y actualizamos las opciones ordenadamente.
  useEffect(() => {
    let stored = localStorage.getItem("CajaPersonaRecibeRecurso")
    if (stored) {
      try {
        const storedValues = JSON.parse(stored) // asumimos que es un arreglo
        // Convertimos los valores almacenados en opciones usando createOption
        const storedOptions = storedValues.map(val => createOption(val))
        // Ordenamos alfabéticamente por label
        storedOptions.sort((a, b) => a.label.localeCompare(b.label))
        setOptionsPersonaRecibeRecurso(storedOptions)
      } catch (e) {
        console.error("Error al parsear los datos de localStorage", e)
      }
    }
    stored = localStorage.getItem("CajaPersonaEntregoRecurso")
    if (stored) {
      try {
        const storedValues = JSON.parse(stored) // asumimos que es un arreglo
        // Convertimos los valores almacenados en opciones usando createOption
        const storedOptions = storedValues.map(val => createOption(val))
        // Ordenamos alfabéticamente por label
        storedOptions.sort((a, b) => a.label.localeCompare(b.label))
        setOptionsPersonaEntregoRecurso(storedOptions)
      } catch (e) {
        console.error("Error al parsear los datos de localStorage", e)
      }
    }
    stored = localStorage.getItem("CajaPersonaAutorizoRecurso")
    if (stored) {
      try {
        const storedValues = JSON.parse(stored) // asumimos que es un arreglo
        // Convertimos los valores almacenados en opciones usando createOption
        const storedOptions = storedValues.map(val => createOption(val))
        // Ordenamos alfabéticamente por label
        storedOptions.sort((a, b) => a.label.localeCompare(b.label))
        setOptionsPersonaAutorizoRecurso(storedOptions)
      } catch (e) {
        console.error("Error al parsear los datos de localStorage", e)
      }
    }
  }, [])

  useEffect(() => {
    console.log("useEffect::conceptosGastoOptions")
    setOpcionesConceptosGasto(conceptosGastoOptions)
  }, [conceptosGastoOptions])

  useEffect(() => {
    console.log("getconceptogastos")
    dispatch(
      getCajaConceptosGasto({
        nombreSolicitud: "getconceptogastos",
      })
    )
  }, [dispatch])

  useEffect(() => {
    if (mensajeExitoso && mensajeExitoso.length) {
      //console.log("useEffect::mensajeExitoso:", mensajeExitoso)
      toast.success(mensajeExitoso, {
        autoClose: 2000,
      })

      dispatch(unsetCajaMensajeExito())

      setValuePersonaRecibeRecurso(null)
      setValuePersonaEntregoRecurso(null)
      setValuePersonaAutorizoRecurso(null)
      setImporte(0.0)

      formik.resetForm()
    }
  }, [dispatch, mensajeExitoso])

  // #endregion

  // #region functions

  const toggleCustom = tab => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab)
      console.log("setcustomActiveTab(tab): ", tab)
    }
  }

  const createOption = label => ({
    label,
    value: label.toLowerCase().replace(/\W/g, ""),
  })

  const handleCreatePersonaRecibeRecurso = inputValue => {
    setIsLoading(true)
    setTimeout(() => {
      const newOption = createOption(inputValue)
      setIsLoading(false)

      // Actualizamos las opciones en el estado
      setOptionsPersonaRecibeRecurso(prev => {
        const newOptions = [...prev, newOption]
        newOptions.sort((a, b) => a.label.localeCompare(b.label))
        return newOptions
      })
      setValuePersonaRecibeRecurso(newOption)

      // Actualizamos localStorage
      let stored = localStorage.getItem("CajaPersonaRecibeRecurso")
      let storedValues = []
      if (stored) {
        try {
          storedValues = JSON.parse(stored)
          if (!Array.isArray(storedValues)) {
            storedValues = []
          }
        } catch (e) {
          storedValues = []
        }
      }
      storedValues.push(inputValue)
      localStorage.setItem(
        "CajaPersonaRecibeRecurso",
        JSON.stringify(storedValues)
      )
    }, 1000)
  }

  const handleCreatePersonaEntregoRecurso = inputValue => {
    setIsLoading(true)
    setTimeout(() => {
      //
      const newOption = createOption(inputValue)
      setIsLoading(false)

      // Actualizamos las opciones en el estado
      setOptionsPersonaEntregoRecurso(prev => {
        const newOptions = [...prev, newOption]
        newOptions.sort((a, b) => a.label.localeCompare(b.label))
        return newOptions
      })
      setValuePersonaEntregoRecurso(newOption)

      // Actualizamos localStorage
      let stored = localStorage.getItem("CajaPersonaEntregoRecurso")
      let storedValues = []
      if (stored) {
        try {
          storedValues = JSON.parse(stored)
          if (!Array.isArray(storedValues)) {
            storedValues = []
          }
        } catch (e) {
          storedValues = []
        }
      }
      storedValues.push(inputValue)
      localStorage.setItem(
        "CajaPersonaEntregoRecurso",
        JSON.stringify(storedValues)
      )
    }, 1000)
  }

  const handleCreatePersonaAutorizoRecurso = inputValue => {
    if (regex.test(inputValue)) {
      setIsLoading(true)
      setTimeout(() => {
        const newOption = createOption(inputValue)
        setIsLoading(false)

        // Actualizamos las opciones en el estado
        setOptionsPersonaAutorizoRecurso(prev => {
          const newOptions = [...prev, newOption]
          newOptions.sort((a, b) => a.label.localeCompare(b.label))
          return newOptions
        })
        setValuePersonaAutorizoRecurso(newOption)

        // Actualizamos localStorage
        let stored = localStorage.getItem("CajaPersonaAutorizoRecurso")
        let storedValues = []
        if (stored) {
          try {
            storedValues = JSON.parse(stored)
            if (!Array.isArray(storedValues)) {
              storedValues = []
            }
          } catch (e) {
            storedValues = []
          }
        }
        storedValues.push(inputValue)
        localStorage.setItem(
          "CajaPersonaAutorizoRecurso",
          JSON.stringify(storedValues)
        )
      }, 1000)
    }
  }

  // Manejador para cambios en el input
  const handleInputChange_Persona_Recibo = (newValue, { action }) => {
    if (action === "input-change") {
      // Filtra los caracteres inválidos
      const sanitizedValue = newValue.replace(/[^A-Za-zÁÉÍÓÚáéíóúÑñÜü\s]/g, "")
      setInputValue(sanitizedValue)
      formik.setFieldValue("Descripcion_Persona_Recibo", sanitizedValue)
      return sanitizedValue
    }
    return newValue
  }

  // Manejador para cambios en el input
  const handleInputChange_Entrego_Recibo = (newValue, { action }) => {
    if (action === "input-change") {
      // Filtra los caracteres inválidos
      const sanitizedValue = newValue.replace(/[^A-Za-zÁÉÍÓÚáéíóúÑñÜü\s]/g, "")
      setInputValue(sanitizedValue)
      formik.setFieldValue("Descripcion_Persona_Entrego_Recibo", sanitizedValue)
      return sanitizedValue
    }
    return newValue
  }

  // Manejador para cambios en el input
  const handleInputChange_Autorizo_Recurso = (newValue, { action }) => {
    if (action === "input-change") {
      // Filtra los caracteres inválidos
      const sanitizedValue = newValue.replace(/[^A-Za-zÁÉÍÓÚáéíóúÑñÜü\s]/g, "")
      setInputValue(sanitizedValue)
      formik.setFieldValue(
        "Descripcion_Persona_Autorizadora_Operacion",
        sanitizedValue
      )
      return sanitizedValue
    }
    return newValue
  }

  const handleFocus = () => {
    if (inputRef.current) {
      inputRef.current.select() // Seleccionar todo el contenido
    }
  }

  // #endregion

  // #region Formik form

  // let initialValuesConsulta = {
  //   Fecha_Desde: primerDiaMes,
  //   Fecha_Hasta: hoy,
  // }

  const initialValues = {
    id_Gasto: -1,
    id_Campus: -1,
    id_Centro_Costos: -1,
    id_Concepto_Gasto: -1,
    id_Documento: -1,
    id_Forma_Pago: -1,
    Cancelado: false,
    Fecha_Creacion: hoy,
    Folio_Documento: "",
    Importe: 0.0,
    Descripcion_Persona_Autorizadora_Operacion: "",
    Descripcion_Persona_Recibo: "",
    Descripcion_Persona_Entrego_Recibo: "",
    Descripcion_Operacion: "",
  }

  // Opción 2: Regex usando propiedades Unicode
  //   Si prefieres una solución más genérica que soporte cualquier carácter de letra Unicode
  //   (incluyendo acentos y otros alfabetos), puedes usar la siguiente expresión regular con la bandera u:
  const validationSchema = Yup.object({
    Descripcion_Persona_Recibo: Yup.string()
      .matches(
        /^[\p{L}]+(?: [\p{L}]+)*$/u,
        "Solo puede contener letras y un espacio entre palabras."
      )
      .required("Requerido"),
    Descripcion_Persona_Entrego_Recibo: Yup.string()
      .matches(
        /^[\p{L}]+(?: [\p{L}]+)*$/u,
        "Solo puede contener letras y un espacio entre palabras."
      )
      .required("Requerido"),
    Descripcion_Persona_Autorizadora_Operacion: Yup.string()
      .matches(
        /^[\p{L}]+(?: [\p{L}]+)*$/u,
        "Solo puede contener letras y un espacio entre palabras."
      )
      .required("Requerido"),
    Descripcion_Operacion: Yup.string().matches(
      /^[\p{L}\p{N}]+(?: [\p{L}\p{N}]+)*$/u,
      "Solo letras y Números."
    ),
    Folio_Documento: Yup.string()
      .matches(/^[\p{L}\p{N}]+(?: [\p{L}\p{N}]+)*$/u, "Solo letras y Números.")
      .required("Requerido"),
    id_Documento: Yup.number()
      .required("Requerido")
      .positive("Debes elegir una opción"),
    id_Centro_Costos: Yup.number()
      .required("Requerido")
      .positive("Debes elegir una opción"),
    id_Concepto_Gasto: Yup.number()
      .required("Requerido")
      .positive("Debes elegir una opción"),
    id_Forma_Pago: Yup.number()
      .required("Requerido")
      .positive("Debes elegir una opción"),
    Importe: Yup.number()
      .required("Requerido")
      .positive("El importe debe ser positivo.")
      .min(1, "El importe debe ser al menos 1."),
  })

  const onSubmit = values => {
    console.log("Form data", values)
    dispatch(
      postCajaAddGasto({
        nombreSolicitud: "postagregargasto",
        id_Gasto: -1,
        idCampus: Number(idCampus),
        id_Centro_Costos: Number(values.id_Centro_Costos),
        id_Concepto_Gasto: Number(values.id_Concepto_Gasto),
        id_Documento: Number(values.id_Documento),
        id_Forma_Pago: Number(values.id_Forma_Pago),
        Cancelado: values.Cancelado,
        Fecha_Creacion: values.Fecha_Creacion,
        Folio_Documento: values.Folio_Documento,
        Importe: parseFloat(values.Importe),
        Descripcion_Persona_Autorizadora_Operacion:
          values.Descripcion_Persona_Autorizadora_Operacion,
        Descripcion_Persona_Recibo: values.Descripcion_Persona_Recibo,
        Descripcion_Persona_Entrego_Recibo:
          values.Descripcion_Persona_Entrego_Recibo,
        Descripcion_Operacion: values.Descripcion_Operacion,
        idPersona: idPersonaAuthenticated,
      })
    )
  }

  const onSubmitConsulta = values => {
    console.log("onSubmitConsulta::Form data", values)
    dispatch(
      getCajaGastos({
        nombreSolicitud: "getgastos",
        idCampus: idCampus,
        fecha_Inicial: values.Fecha_Desde,
        fecha_final: values.Fecha_Hasta,
      })
    )
  }

  const handleUpperCaseChange = event => {
    // Obtiene el nombre del campo y el valor en mayúsculas
    const name = event.target.name
    const value = event.target.value.toUpperCase()

    // Utiliza Formik para actualizar el valor
    formik.setFieldValue(name, value)
  }

  const handleCustomOnBlur = name => {
    console.log(name)
    formik.setFieldTouched(name)
  }

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: onSubmit,
    enableReinitialize: true,
  })

  const formikConsulta = useFormik({
    initialValues: initialValuesConsulta,
    onSubmit: onSubmitConsulta,
    enableReinitialize: true,
  })

  useEffect(() => {
    if (gastos) {
      console.log("gastos: ", gastos)
      setNumeroTotalGastos(gastos.length)
      if (gastos.length > 0) {
        setNumeroRegistroGasto(1)
        setGastoCurrent(gastos[0])
        initialValuesConsulta = gastos[0]
        if (formikConsulta) {
          console.log("initialValuesConsulta: ", initialValuesConsulta)
          formikConsulta.resetForm({ values: initialValuesConsulta })
        }
      } else {
        setNumeroRegistroGasto(0)
        setGastoCurrent({})
      }
    }
  }, [gastos])

  // #endregion

  // console.log("formik.touched", formik.touched)
  // console.log("formik.errors", formik.errors)

  return (
    <React.Fragment>
      <ToastContainer />
      <Nav tabs className="nav-tabs-custom nav-justified">
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({
              active: customActiveTab === "1",
            })}
            onClick={() => {
              toggleCustom("1")
            }}
          >
            <span className="d-block d-sm-none">
              <i className="fas fa-home"></i>
            </span>
            <span className="d-none d-sm-block">Gastos</span>
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({
              active: customActiveTab === "2",
            })}
            onClick={() => {
              toggleCustom("2")
            }}
          >
            <span className="d-block d-sm-none">
              <i className="far fa-user"></i>
            </span>
            <span className="d-none d-sm-block">Consulta de Gastos</span>
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({
              active: customActiveTab === "3",
            })}
            onClick={() => {
              toggleCustom("3")
            }}
          >
            <span className="d-block d-sm-none">
              <i className="far fa-user"></i>
            </span>
            <span className="d-none d-sm-block">Transferencias</span>
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={customActiveTab} className="p-3 text-muted">
        <TabPane tabId="1">
          <Row>
            <Col sm="12">
              <Form onSubmit={formik.handleSubmit}>
                <FormularioGastos
                  formik={formik}
                  modo="captura"
                  isLoading={false}
                  optionsPersonaRecibeRecurso={optionsPersonaRecibeRecurso}
                  optionsPersonaEntregoRecurso={optionsPersonaEntregoRecurso}
                  optionsPersonaAutorizoRecurso={optionsPersonaAutorizoRecurso}
                  documentosOptions={documentosOptions}
                  costosOptions={costosOptions}
                  conceptosGastoOptions={opcionesConceptosGasto}
                  formaPagoOptions={formaPagoOptions}
                  handleCreatePersonaRecibeRecurso={
                    handleCreatePersonaRecibeRecurso
                  }
                  handleCreatePersonaEntregoRecurso={
                    handleCreatePersonaEntregoRecurso
                  }
                  handleCreatePersonaAutorizoRecurso={
                    handleCreatePersonaAutorizoRecurso
                  }
                  handleUpperCaseChange={handleUpperCaseChange}
                />
              </Form>
            </Col>
          </Row>
        </TabPane>
        <TabPane tabId="2">
          {/* Formulario desde hasta */}
          <Form onSubmit={formikConsulta.handleSubmit}>
            <Row>
              <Col sm="12">
                <Row>
                  <Col sm="5">
                    <div className="mb-3">
                      <FormikDatePicker
                        formik={formikConsulta}
                        label="De:"
                        name="Fecha_Desde"
                        placeholder="Desde"
                      />
                    </div>
                  </Col>
                  <Col sm="5">
                    <div className="mb-3">
                      <FormikDatePicker
                        formik={formikConsulta}
                        label="Hasta:"
                        name="Fecha_Hasta"
                        placeholder="Hasta"
                      />
                    </div>
                  </Col>
                  <Col sm="2">
                    <div className="d-flex justify-content-end mt-4">
                      <button
                        type="submit"
                        className="btn btn-primary w-md"
                        disabled={!formikConsulta.isValid}
                      >
                        Consultar
                      </button>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <CustomPagination
                    currentPage={numeroRegistroGasto}
                    totalPages={numeroTotalGastos}
                    onPageChange={registroNumero => {
                      if (gastos.length > 0) {
                        setNumeroRegistroGasto(registroNumero)
                        setGastoCurrent(gastos[registroNumero - 1])
                        initialValuesConsulta = gastos[registroNumero - 1]
                        if (formikConsulta) {
                          formikConsulta.resetForm({
                            values: initialValuesConsulta,
                          })
                        }
                      } else {
                        setNumeroRegistroGasto(0)
                        setGastoCurrent({})
                      }
                    }}
                  />
                </Row>
              </Col>
            </Row>
          </Form>

          {/* Formulario para canelar el gasto en display */}
          <Row>
            <Col sm="12">
              <FormularioGastosReadOnly
                formik={formikConsulta}
                modo="despliegue"
                isLoading={false}
                optionsPersonaRecibeRecurso={optionsPersonaRecibeRecurso}
                optionsPersonaEntregoRecurso={optionsPersonaEntregoRecurso}
                optionsPersonaAutorizoRecurso={optionsPersonaAutorizoRecurso}
                documentosOptions={documentosOptions}
                costosOptions={costosOptions}
                conceptosGastoOptions={opcionesConceptosGasto}
                formaPagoOptions={formaPagoOptions}
              />
              <div className="d-flex justify-content-end mt-2">
                <button
                  type="submit"
                  className="btn btn-danger w-md"
                  disabled={!formikConsulta.isValid}
                >
                  Cancelar
                </button>
              </div>
            </Col>
          </Row>
        </TabPane>
        <TabPane tabId="3">
          <Row>
            <Col sm="12">Transferencias</Col>
          </Row>
        </TabPane>
      </TabContent>
    </React.Fragment>
  )
}

export default GastosComponent
